import React, { useState } from 'react';

interface FeedbackPanelProps {
  onSubmit: (feedbackText: string) => void;
  onCancel: () => void;
}

export const FeedbackPanel: React.FC<FeedbackPanelProps> = ({ onSubmit, onCancel }) => {
  const [feedbackText, setFeedbackText] = useState('');

  const handleSubmit = () => {
    onSubmit(feedbackText);
  };

  return (
    <div className="mt-2 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded">
      <div className="flex items-start justify-between mb-2">
        <h4 className="text-sm font-medium text-gray-900 dark:text-white">
          Additional feedback (optional)
        </h4>
        <button
          onClick={onCancel}
          className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
        >
          ✕
        </button>
      </div>
      <textarea
        value={feedbackText}
        onChange={(e) => setFeedbackText(e.target.value)}
        placeholder="Tell us more about your experience..."
        rows={3}
        className="w-full px-3 py-2 border dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm resize-none"
      />
      <div className="flex justify-end gap-2 mt-2">
        <button
          onClick={onCancel}
          className="px-3 py-1 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
        >
          Skip
        </button>
        <button
          onClick={handleSubmit}
          className="px-3 py-1 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded"
        >
          Submit
        </button>
      </div>
    </div>
  );
};
